import { createSelector } from "@reduxjs/toolkit";

const selectFirstName = (state) => state.accountCreation.firstName;
const selectLastName = (state) => state.accountCreation.lastName;
const selectDateOfBirth = (state) => state.accountCreation.dateOfBirth;
const selectPreferredContact = (state) =>
  state.accountCreation.preferredContact;
const selectEmail = (state) => state.accountCreation.email;
const selectPhone = (state) => state.accountCreation.phone;
const selectUserName = (state) => state.accountCreation.userName;
const selectPassword = (state) => state.accountCreation.password;
const selectUsernameApiResponse = (state) =>
  state.accountCreation.usernameApiResponse;
const selectPasswordApiResponse = (state) =>
  state.accountCreation.passwordApiResponse;
const selectResendOTPDescription = (state) =>
  state?.accountCreation?.sendOTPDescription;
const selectValidateOTPDesc = (state) =>
  state?.accountCreation?.validateOTPDescription;
const selectAccountCreationStatus = (state) =>
  state?.accountCreation?.accountCreationStatus;
const selectPrefVerificationMethod = (state) =>
  state?.accountCreation?.prefVerificationMethod;
const selectAuthToken = (state) => state?.accountCreation?.authToken;
const selectEmailLanguage = (state) => state?.accountCreation?.emailLanguage;

export const manageAccountCreationSelector = createSelector(
  [
    selectFirstName,
    selectLastName,
    selectDateOfBirth,
    selectPreferredContact,
    selectEmail,
    selectPhone,
    selectUserName,
    selectPassword,
    selectUsernameApiResponse,
    selectPasswordApiResponse,
    selectResendOTPDescription,
    selectValidateOTPDesc,
    selectAccountCreationStatus,
    selectPrefVerificationMethod,
    selectAuthToken,
    selectEmailLanguage,
  ],
  (
    firstName,
    lastName,
    dateOfBirth,
    preferredContact,
    email,
    phone,
    userName,
    password,
    usernameApiResponse,
    passwordApiResponse,
    resendOTPDescription,
    validateOTPDesc,
    accountCreationStatus,
    accountPrefVerificationMethod,
    authToken,
    emailLanguage
  ) => ({
    firstName,
    lastName,
    dateOfBirth,
    preferredContact,
    email,
    phone,
    userName,
    password,
    usernameApiResponse,
    passwordApiResponse,
    resendOTPDescription,
    validateOTPDesc,
    accountCreationStatus,
    accountPrefVerificationMethod,
    authToken,
    emailLanguage,
  })
);
